import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFinSadaad } from "../../../../store/Api";
import { setBreadCrumb } from "../../../../store/userSlice";
import FileUploadElement from "../../../../ReusableComponents/UploadFile/uplaodFile";

import FinListDataSadaad from "./FinListDataSadaad";

export default function FinSadaad() {
  const SadaadDataList = useSelector((state) => state.finSadaad);
  const [trigger, setTrigger] = useState();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
  });

  const token = localStorage.getItem("nodeToken");

  //screen Title Show fun
  const titleBorder = [
    {
      label: "SADAAD GENERATION - FINANCE-SADAAD PAYMENT",
      link: "/dashboard/sadaad",
    },
  ];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
    dispatch(getFinSadaad(token));
  }, [trigger]);

  const updateData = () => {
    dispatch(getFinSadaad(token));
  };

  return (
    <>
      {showPromptElement.open && (
        <FileUploadElement
          title={"Upload Tamplate with Border Number"}
          subTitle={"Upload templete"}
          showFileUploadElement={showPromptElement}
          setShowFileUploadElement={setShowPromptElement}
        />
      )}
      <div className={`ml-5 mr-5`}>
        <FinListDataSadaad
          list={SadaadDataList}
          loading={loading}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "BORDER NUMBER",
            "Sadaad Type",
            "VISA PROVIDER",
            "SPONSOR ID",
            "CLIENT NAME",
            "IQAMA APPLIED DATE",
            "SADAAD NUMBER",
            "TERM",
            "IQAMA FEES",
            "WORK PERMIT FEES",
            "OTHER FEES",
            "SADAAD PAYMENT STATUS",
            "SADAAD EMPLOYEE COUNT",
            "",
          ]}
          token={token}
          updateData={updateData}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      </div>
    </>
  );
}
